export default {
  xs: '600px',
  md: '960px',
  lg: '1280px',
};
